// Configuration des champs du PDF Cerfa
export const PDF_CONFIG = {
  // Mapping des boutons radio vers les checkboxes du PDF
  radioGroups: {
    // Type de personne (titulaire)
    typePersonne: {
      fields: ['TIT_1', 'TIT_2'],
      values: {
        'TIT_1': { TIT_1: 'Yes', TIT_2: 'Off' },  // Personne physique
        'TIT_2': { TIT_1: 'Off', TIT_2: 'Yes' }   // Personne morale
      }
    },

    // Sexe
    sexe: {
      fields: ['TIT_1_1', 'TIT_1_2'],
      values: {
        'Oui': { TIT_1_1: 'Yes', TIT_1_2: 'Off' },  // Homme
        'Non': { TIT_1_1: 'Off', TIT_1_2: 'Yes' }   // Femme
      }
    },

    // Usage
    usage: {
      fields: ['VEH_5_1', 'VEH_5_2'],
      values: {
        'Oui': { VEH_5_1: 'Yes', VEH_5_2: 'Off' },
        'Non': { VEH_5_1: 'Off', VEH_5_2: 'Yes' }
      }
    },

    // Nuance
    nuance: {
      fields: ['VEH_30', 'VEH_31'],
      values: {
        'Clair': { VEH_30: 'Yes', VEH_31: 'Off' },
        'Foncé': { VEH_30: 'Off', VEH_31: 'Yes' }
      }
    },

    // Type de location
    typeLocation: {
      fields: ['LOC_2', 'LOC_3'],
      values: {
        'LOC_2': { LOC_2: 'Yes', LOC_3: 'Off' },  // Courte durée
        'LOC_3': { LOC_2: 'Off', LOC_3: 'Yes' }   // Longue durée
      }
    },

    // Type de certification
    certificationType: {
      fields: ['CCV_1', 'CCV_2'],
      values: {
        'CCV_1': { CCV_1: 'Yes', CCV_2: 'Off' },  // Du constructeur
        'CCV_2': { CCV_1: 'Off', CCV_2: 'Yes' }   // Du représentant accrédité
      }
    },

    // Certification
    CERTIFICATION: {
      fields: ['CCV_1', 'CCV_2'],
      mappings: {
        constructeur: { field: 'CCV_1', value: 'Yes' },
        representant: { field: 'CCV_2', value: 'Yes' }
      }
    },

    // Couleur dominante
    COULEUR: {
      fields: [
        'VEH_32_1', 'VEH_32_2', 'VEH_32_3', 'VEH_32_4', 'VEH_32_5',
        'VEH_32_6', 'VEH_32_7', 'VEH_32_8', 'VEH_32_9', 'VEH_32_10'
      ],
      mappings: {
        'Noir': { field: 'VEH_32_1', value: 'Yes' },
        'Marron': { field: 'VEH_32_2', value: 'Yes' },
        'Rouge': { field: 'VEH_32_3', value: 'Yes' },
        'Orange': { field: 'VEH_32_4', value: 'Yes' },
        'Jaune': { field: 'VEH_32_5', value: 'Yes' },
        'Vert': { field: 'VEH_32_6', value: 'Yes' },
        'Bleu': { field: 'VEH_32_7', value: 'Yes' },
        'Beige': { field: 'VEH_32_8', value: 'Yes' },
        'Gris': { field: 'VEH_32_9', value: 'Yes' },
        'Blanc': { field: 'VEH_32_10', value: 'Yes' }
      }
    }
  },

  // Champs de date qui doivent être décomposés
  dateFields: {
    // Date de naissance
    'TIT_5': {
      prefix: 'TIT_5'
    },
    // Date de réception par type
    'VDE_2': {
      prefix: 'VDE_2'
    },
    // Date de vente
    'dateVente': {
      prefix: 'VDE_DATE'
    }
  },

};

export default PDF_CONFIG;
